import { Glow } from '@/components/ui';

/**
 * The spot lights behind a page's opening section, as the frames set them: a
 * violet one high on the left, just under the header, and a softer lilac one
 * halfway down the right edge, over flat night. The section needs to be
 * `relative overflow-hidden`.
 */
export function HeroLights() {
  return (
    <>
      <Glow className="top-16 -left-56" size={560} tone="#9B45FF" opacity={0.4} blur={80} />
      <Glow className="top-1/3 -right-64" size={480} tone="#B77CF0" opacity={0.3} blur={80} />
    </>
  );
}
